import { t } from "i18next";

export const projectStatusTypes = () => [
  { key: 1, label: t("Active"), value: "1" },
  { key: 2, label: t("Inactive"), value: "0" },
];

export const billingFrequencyOptions = () => [
  { key: 1, label: t("Monthly"), value: "monthly" },
  { key: 2, label: t("Quarterly"), value: "quarterly" },
  { key: 2, label: t("Annually"), value: "annually" },
];

export const booleanOptions = () => [
  { key: 1, label: t("Yes"), value: "true" },
  { key: 2, label: t("No"), value: "false" },
];

export const genderList = () => [
  { label: t("Male"), value: "male" },
  { label: t("Female"), value: "female" },
  { label: t("Others"), value: "other" },
];

export const taxFillerStatus = () => [
  { label: t("Filer"), value: "1" },
  { label: t("Non Filer"), value: "0" },
];

export const clientIdTypes = () => [
  {
    label: t("CNIC"),
    value: "cnic",
    mask: "xxxxx-xxxxxxx-x",
    maxLength: 15,
    allowInput: (value) => value.replace(/\D/g, ""), // Only numbers
  },
  {
    label: t("NICOP"),
    value: "nicop",
    mask: "xxxxxx-xxxxxx-x",
    maxLength: 15,
    allowInput: (value) => value.replace(/\D/g, ""), // Only numbers
  },
  {
    label: t("Passport"),
    value: "passport",
    mask: null,
    maxLength: 9,
    allowInput: (value) => value.replace(/[^a-zA-Z0-9]/g, ""), // Allow letters & numbers
  },
];

/** Default ID type option (CNIC) for form prefills when order of clientIdTypes changes */
export const defaultClientIdCardType = () =>
  clientIdTypes().find((o) => o.value === "cnic") ?? clientIdTypes()[0];

export const unitStatusColors = () => ({
    "live-in": { title: t("Live In"), color: "#E6F5F9", textColor: "#0091BA" },
    rented: { title: t("LTR"), color: "#E9F8ED", textColor: "#009F2B" },
    "short-term-rental": {
      title: t("STR"),
      color: "#FFF7E6",
      textColor: "#D48806",
    },
    vacant: { title: t("Vacant"), color: "#F5F5F5", textColor: "#707070" },
    reserved: { title: t("Reserved"), color: "#E1F2F0", textColor: "#006169" },
})

export const unitDefaultFilters = () => ({
  sorts : "created_at desc", 
  "q[status_slug_eq]": "all"
})

export const paymentStatusColors = () => ({
  received: { title: t("Received"), color: "#E6F5F9", textColor: "#0091BA" },
  reconcile: { title: t("Reconcile"), color: "#FFEFE5", textColor: "#FF5F00" },
  cleared: { title: t("Cleared"), color: "#E9F8ED", textColor: "#009F2B" },
  rejected: { title: t("Rejected"), color: "#FEF2F2", textColor: "#E83A3A" },
  approved: { title: t("Approved"), color: "#E7F8F5", textColor: "#1C6758" },
})

export const paymentDefaultFilters = () => ({
  sorts : "created_at desc", 
  "q[status_slug_eq]": "all"
})

export const visitDefaultFilters = () => ({
  active_tab: "today",
  sorts: "visit_start_time asc",
})

export const getVisitColors = () => ({
  pending: { title: t("Pending"), color: "#E6F5F9", textColor: "#0091BA" },
  verified: { title: t("Verified"), color: "#E9F8ED", textColor: "#009F2B" },
  completed: { title: t("Completed"), color: "#F1EDFA", textColor: "#7747CE" },
  cancelled: { title: t("Cancelled"), color: "#FEF2F2", textColor: "#E83A3A" },
});

export const VISIT_STATUS_TRANSITIONS = {
  pending: ["verified", "cancelled"],
  verified: [],
  completed: [],
  cancelled: [],
}

export const dashbaordUnitTabs = () => [
  {
    componentType: "pieChart",
    tab: t("All"),
    key: "all",
    loadType: "all",
    extraTitle: t("Total Units"),
  },
  {
    componentType: "pieChart",
    tab: t("Vacant"),
    key: "vacant",
    loadType: "vacant",
    extraTitle: t("Total Vacant Units"),
  },
  {
    componentType: "pieChart",
    tab: t("Live In"),
    key: "live_in",
    loadType: "live_in",
    extraTitle: t("Total Live In Units"),
  },
  {
    componentType: "pieChart",
    tab: t("Rented"),
    key: "rented",
    loadType: "rented",
    extraTitle: t("Total Rented Units"),
  },
];

export const addTypes = (addSuffix) => [
  { label: t("New" + " " + addSuffix), value: "new" },
  { label: t("Existing" + " " + addSuffix), value: "existing" },
];

export const getStatus = () => ({
  active: { title: t("Active"), color: "#E9F8ED", textColor: "#009F2B" },
  draft: { title: t("Draft"), color: "#E6F5F9", textColor: "#0091BA" },
  "pending-settlement": {
    title: t("Pending Settlement"),
    color: "#FFFAEB",
    textColor: "#B7791F",
  },
  expired: { title: t("Expired"), color: "#FEF2F2", textColor: "#E83A3A" },
  cancelled: { title: t("Cancelled"), color: "#F5F5F5", textColor: "#707070" },
  terminating: { title: t("Terminating"), color: "#FFEFE5", textColor: "#FF5F00" },
  terminated: { title: t("Terminated"), color: "#FDE7E9", textColor: "#B20E1A" },
  in_active: { title: t("In Active"), color: "#FEF2F2", textColor: "#E83A3A" }
});

export const workOrderDefaultFilters = () => ({
  sorts : "created_at desc", 
  active_tab: "all"
})

export const workOrderStatusColors = () => ({
  "pending-procurement": {
    title: t("Pending Procurement"),
    color: "#fbf6e4",
    textColor: "#d5a700",
  },
  pending: { title: t("Pending"), color: "#E6F5F9", textColor: "#0091BA" },
  "in-progress": {
    title: t("In Progress"),
    color: "#FFEFE5",
    textColor: "#FF5F00",
  },
  completed: { title: t("Completed"), color: "#E9F8ED", textColor: "#009F2B" },
  rejected: { title: t("Rejected"), color: "#FEF2F2", textColor: "#E83A3A" },
})

export const rmsBookingStatusColors = () => ({
  draft: { title: t("Draft"), color: "#FFFAEB", textColor: "#F97B0C" },
  matured: { title: t("Matured"), color: "#E9F8ED", textColor: "#009F2B" },
  "in-possession": {
    title: t("In Possession"),
    color: "#E1F2F0",
    textColor: "#006169",
  },
  transferring: {
    title: t("Transferring"),
    color: "#E6F5F9",
    textColor: "#0091BA",
  },
  transferred: {
    title: t("Transferred"),
    color: "#F1EDFA",
    textColor: "#7747CE",
  },
  active: { title: t("Active"), color: "#EDF3FE", textColor: "#3A77FF" },
  "on-hold": { title: t("On Hold"), color: "#FFFAEB", textColor: "#B7791F" },
  terminating: { title: t("Terminating"), color: "#FEF2F2", textColor: "#E83A3A" },
  terminated: { title: t("Terminated"), color: "#F5F5F5", textColor: "#707070" },
})

export const rmsBookingTypeColors = () => ({
  joint: { title: t("Joint"), color: "#F1EDFA", textColor: "#7747CE" },
  individual: {
    title: t("Individual"),
    color: "#E6F5F9",
    textColor: "#0091BA",
  },
  organisation: {
    title: t("Organisation"),
    color: "#F5F5F5",
    textColor: "#707070",
  },
});

export const rmsRefundStatusColors = () => ({
  complete: { title: t("Complete"), color: "#E9F8ED", textColor: "#009F2B" },
  pending: { title: t("Pending"), color: "#F5F5F5", textColor: "#707070" },
});

export const rmsPaymentStatusColors = () => ({
  verified: { title: t("Verified"), color: "#E9F8ED", textColor: "#009F2B" },
  pending: { title: t("Pending"), color: "#F5F5F5", textColor: "#707070" },
  rejected: { title: t("Rejected"), color: "#FEF2F2", textColor: "#E83A3A" },
  received: { title: t("Received"), color: "#EDF3FE", textColor: "#3A77FF" },
  negative: { title: t("Negative"), color: "#fbf6e4", textColor: "#d5a700" },
});

export const rmsTransferStatusColors = () => ({
  pending: { title: t("Pending"), color: "#E6F5F9", textColor: "#0091BA" },
  "pending-payment": {
    title: t("In Progress"),
    color: "#FFFAEB",
    textColor: "#F97B0C",
  },
  completed: { title: t("Completed"), color: "#E9F8ED", textColor: "#009F2B" },
  cancelled: { title: t("Cancelled"), color: "#F5F5F5", textColor: "#707070" },
});

export const rmsPaymentStatusUpdates = () => [
  { label: t("Verify"), value: "verify" },
  { label: t("Reject"), value: "reject" },
];

export const nocRequestStatusColors = () => ({
  pending: { title: t("Pending"), color: "#FFFAEB", textColor: "#F97B0C" },
  "in-progress": {
    title: t("In Progress"),
    color: "#E6F5F9",
    textColor: "#0091BA",
  },
  completed: { title: t("Completed"), color: "#E9F8ED", textColor: "#009F2B" },
  rejected: { title: t("Rejected"), color: "#FEECEC", textColor: "#E5484D" },
});

export const getNocSubStageLabel = (subStage) =>
  ({
    first_visit_scheduled: t("First Visit Scheduled"),
    documents_collected: t("Documents Collected"),
  }[subStage] || "");

export const getNocStatusTagData = (statusSlug, subStage) => {
  const base = nocRequestStatusColors()[statusSlug];
  if (!base) return null;
  const subStageLabel =
    statusSlug === "in-progress" ? getNocSubStageLabel(subStage) : "";
  return subStageLabel
    ? { ...base, title: `${base.title} · ${subStageLabel}` }
    : base;
};

export const nocSourceList = () => [
  { label: t("Client"), name: t("Client"), value: "client_app", slug: "client_app" },
  { label: t("Staff"), name: t("Staff"), value: "staff", slug: "staff" },
];

export const getNocSourceLabel = (source) =>
  ({ client_app: t("Client"), staff: t("Staff") }[source] || source || "-");

export const nocStatusList = () => [
  { label: t("Pending"), name: t("Pending"), value: "pending", slug: "pending" },
  {
    label: t("In Progress"),
    name: t("In Progress"),
    value: "in-progress",
    slug: "in-progress",
  },
  {
    label: t("Completed"),
    name: t("Completed"),
    value: "completed",
    slug: "completed",
  },
  {
    label: t("Rejected"),
    name: t("Rejected"),
    value: "rejected",
    slug: "rejected",
  },
];

export const nocStatusOptionsFor = (status, subStage) => {
  const all = nocStatusList();
  const byValue = (value) => all.find((option) => option.value === value);

  if (status === "pending") {
    return [byValue("pending"), byValue("in-progress"), byValue("rejected")];
  }
  if (status === "in-progress") {
    return [
      byValue("in-progress"),
      ...(subStage === "documents_collected" ? [byValue("completed")] : []),
      byValue("rejected"),
    ];
  }
  return [byValue(status)].filter(Boolean);
};

export const nocRequiredDocumentsList = () => [
  { label: t("Signed Cheques"), value: "signed_cheques" },
  { label: t("Advance Facility Bills"), value: "advance_facility_bills" },
  { label: t("Others"), value: "others" },
];

export const getNocRequiredDocumentLabel = (value) =>
  ({
    signed_cheques: t("Signed Cheques"),
    advance_facility_bills: t("Advance Facility Bills"),
    others: t("Others"),
  }[value] || value);

export const rmsDashboardUnitTabs = () => [
  {
    componentType: "pieChart",
    tab: t("All"),
    key: "all",
    loadType: "all",
    extraTitle: t("Total Units"),
  },
  {
    componentType: "pieChart",
    tab: t("Available"),
    key: "available",
    loadType: "available",
    extraTitle: t("Total Available Units"),
  },
  {
    componentType: "pieChart",
    tab: t("Booked"),
    key: "booked",
    loadType: "booked",
    extraTitle: t("Total Booked Units"),
  },
];

export const rmsUnitsStatusColors = () => ({
  matured: { title: t("Matured"), color: "#E9F8ED", textColor: "#008725" },
  booked: { title: t("Booked"), color: "#EDF8F0", textColor: "#009F2B" },
  "in-active": { title: t("Inactive"), color: "#F5F5F5", textColor: "#707070" },
  available: { title: t("Available"), color: "#E6F5F9", textColor: "#0091BA" },
});

export const rmsRecoveryLeadStatusColors = () => ({
  pending: { title: t("Pending"), color: "#E6F5F9", textColor: "#0091BA" },
  "in-progress": {
    title: t("In Progress"),
    color: "#FFEFE5",
    textColor: "#FF5F00",
  },
  completed: { title: t("Completed"), color: "#E9F8ED", textColor: "#009F2B" },
  resolved: { title: t("Resolved"), color: "#EDF3FE", textColor: "#3A77FF" },
  default: { title: t("Default"), color: "#F5F5F5", textColor: "#707070" },
});

export const rmsInstallmentsStatusColors = () => ({
  pending: { title: t("Pending"), color: "#F5F5F5", textColor: "#707070" },
  received: {
    title: t("Received"),
    color: "#E6F5F9",
    textColor: "#0091BA",
  },
  paid: { title: t("Paid"), color: "#E9F8ED", textColor: "#009F2B" },
  due: { title: t("Due"), color: "#FFFAEB", textColor: "#F97B0C" },
  overdue: { title: t("Overdue"), color: "#FEF2F2", textColor: "#E83A3A" },
});

export const issueTypes = () => [
  { key: 1, label: t("Request"), value: "request" },
  { key: 2, label: t("Complaint"), value: "complaint" },
]

export const issueContactMethods = () => [
  { key: 1, label: t("Phone"), value: "phone" },
  { key: 2, label: t("Whatsapp"), value: "whatsapp" },
  { key: 3, label: t("Email"), value: "email" },
]
 
export const urgencyColors = () => ({
  low: { title: t("Low"), color: "#A7A7A7" },
  medium: { title: t("Medium"), color: "#D6A700" },
  high: { title: t("High"), color: "#DA6700" }, 
  critical: { title: t("Critical"), color: "#E83A3A" },
});


export const targetStatusColors = () => ({
  approved: { title: t("Approved"), color: "#E9F8ED", textColor: "#009F2B" },
  "not-set": { title: t("Not Set"), color: "#F5F5F5", textColor: "#707070" },
  "pending-approval": {
    title: t("Pending Approval"),
    color: "#FFFAEB",
    textColor: "#F97B0C", 
  },
  rejected: { title: t("Rejected"), color: "#FEF2F2", textColor: "#E83A3A" },
});
/**
 * Bed counts — plain integers, with the display mapping owned entirely by the FE.
 *
 * The backend never sends a label for a bed count, and there is no endpoint for the
 * option list: it is fixed here. Changing it is a web release.
 *
 *   -1  → "-"    (a configured "no beds" value, e.g. a shop or parking bay)
 *   1-9 → "1"-"9"
 *   10  → "10+"
 *
 * `-1` and `null` both render as a dash-like glyph and are easy to conflate, but they
 * mean different things: `-1` was configured, `null` was never set. Only the latter
 * gets an em dash.
 */
export const BED_COUNT_NONE = -1
export const BED_COUNT_MAX = 10
export const EM_DASH = "—"

export const bedCountLabel = (value) => {
  if (value === null || value === undefined || value === "") return EM_DASH
  const num = Number(value)
  if (!Number.isFinite(num)) return EM_DASH
  if (num === BED_COUNT_NONE) return "-"
  if (num >= BED_COUNT_MAX) return `${BED_COUNT_MAX}+`
  return String(num)
}

/** Joins a derived `bed_counts[]`; an em dash when there is nothing configured. */
export const bedCountsLabel = (values) =>
  Array.isArray(values) && values.length
    ? values.map(bedCountLabel).join(", ")
    : EM_DASH

/** The fixed option list for the Property Category form's Beds multi-select. */
export const bedCountOptions = () =>
  [BED_COUNT_NONE, 1, 2, 3, 4, 5, 6, 7, 8, 9, BED_COUNT_MAX].map((value) => ({
    label: bedCountLabel(value),
    value,
  }))

/**
 * A unit's Baths dropdown. `bath_count` uses the same integer encoding as beds
 * (-1 → "-", 10 → "10+"), so it shares the labels; the list is fixed and FE-owned.
 */
export const bathCountOptions = () => bedCountOptions()

/** Options for a Unit, built from the integers `property_bed_counts` returned. */
export const bedCountOptionsFrom = (values) =>
  (Array.isArray(values) ? values : []).map((value) => ({
    label: bedCountLabel(value),
    value,
  }))
